import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { UnauthorizedPage } from "./UnauthorizedPage";
import { FetchSecurityMaster } from "../api/api";
import Cookies from "js-cookie";
import _ from "lodash";

interface RouteHandlerProps {
  children: React.ReactNode;
}

function RouteHandler({ children }: RouteHandlerProps): JSX.Element {
  const [menuItems, setMenuItems] = useState<any>([]);
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  let location = useLocation();
  let navigate = useNavigate();
  const selectedClient: any = Cookies.get("client");

  useEffect(() => {
    FetchSecurityMaster(
      "ProductMenuList",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setMenuItems(response); // Assuming the API response is a single menu item object
      setIsLoading(false);
    });
  }, []);

  const getLocation = location.pathname.split("/").filter((part) => part)[1];
  const currentPageItem = _.find(menuItems, {
    toURL: getLocation.toLowerCase(),
  });
  
  if (
    isLoading === false &&
    menuItems.length > 0 &&
    currentPageItem?.webPageStatus === "N"
  ) {
    return <Navigate to="/unauthorized" />;
  }

  function isTokenExpired(token:any) {
    const decodedToken = JSON.parse(atob(token.split('.')[1])); // Decoding the token payload
    const expirationTime = new Date(decodedToken.exp * 1000); // Converting expiration timestamp to Date object
    const currentTime = new Date(); // Current time
  
    return expirationTime < currentTime; // Checking if the token has expired
  }
  
  // Usage example
  const token = Cookies.get("newJwt"); // Assuming the token is stored in local storage
  const isExpired = isTokenExpired(token);
  if (isExpired) {
    return <Navigate to="/" />;
  }

  return <div>{children}</div>;
}

export { RouteHandler };
